export class Autenticacao {
  sucesso = false;
  erro = '';
}
